<template>
  <div>
    <v-stepper v-model="el">
      <v-stepper-header>
        <v-stepper-step step="1" color="#76cee6">Choose Your Manifest</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step step="2" color="#64b0d7">Confirm Your Manifest Information</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step step="3" color="#083a95">Manifest Summary Information</v-stepper-step>
      </v-stepper-header>

      <v-divider></v-divider>

      <v-stepper-content step="1" class="pa-0">
        <v-container container--fluid grid-list-md>
              <ManifestUploaderHeader
                :key="keyUploader"
                v-if="propsHeader"
                :props-header="propsHeader"
                v-on:manifest-submitted="manifestSubmitted"
                v-on:alert="displayDialog"
              ></ManifestUploaderHeader>
              <ManifestChecker
                v-if="jobId!==null"
                :active="jobId !== null"
                :job-id="jobId"
                v-on:manifest-checked="manifestChecked"
                v-on:alert="displayDialog"
              ></ManifestChecker>
        </v-container>
      </v-stepper-content>

      <!--<v-stepper-content step="2">-->
      <!--<v-container container--fluid grid-list-md>-->
      <!-- <v-row justify-center align-center fill height>-->
      <!--<v-col cols="12">-->
      <!--<ManifestChecker :active="el===2"-->
      <!--:job-id="jobId"-->
      <!--v-if="jobId"-->
      <!--v-on:manifest-checked="manifestChecked"-->
      <!--v-on:alert="displayDialog"-->
      <!--&gt;</ManifestChecker>-->
      <!--</v-col>-->
      <!-- </v-row>-->
      <!--</v-container>-->
      <!--</v-stepper-content>-->

      <v-stepper-content step="2" class="px-0">
        <v-container container--fluid grid-list-md>
           <v-row justify="center" align="center" fill height>
            <v-col cols="12">
              <ManifestConfirmation
                v-if="el===2"
                :data-table-props="dataTableProps"
                :job-id="jobId"
                v-on:back-to-upload="backToUpload"
                v-on:manifest-confirmed="manifestConfirmed"
              ></ManifestConfirmation>
            </v-col>
            <v-col cols="12">
              <ManifestChecker
                v-if="manifestCheckerActive"
                :active="manifestCheckerActive"
                :job-id="jobId"
                v-on:manifest-checked="manifestFinalChecked"
              ></ManifestChecker>
            </v-col>
           </v-row>
        </v-container>
      </v-stepper-content>

      <v-stepper-content step="3">
        <ManifestSummary :results="results"></ManifestSummary>
      </v-stepper-content>


      <v-dialog
        v-model="dialog"
        max-width="500px"
      >
        <v-card>
          <v-card-title>
            ALERT
          </v-card-title>
          <v-card-text>
            {{dialogMessage}}
          </v-card-text>
          <v-card-actions class="justify-center">
            <v-btn
              color="blue darken-1"
              text
              @click="dialog=false">
              OK
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </v-stepper>
  </div>
</template>

<script>
  import ManifestChecker from "../../util/Manifest/ManifestChecker";
  import ManifestConfirmation from "../../util/Manifest/ManifestConfirmation";
  import axios from 'axios'
  import ManifestUploaderHeader from "../../util/Manifest/ManifestUploaderHeader";
  import ManifestSummary from "../../util/Manifest/ManifestSummary";

  // @vuese
  // Component/page that contains all the components needed to upload a manifest
  // @group Manifest
  export default {
    name: "UploadYourManifest",
    components: {ManifestSummary, ManifestUploaderHeader, ManifestConfirmation, ManifestChecker,},
    data() {
      return {
        el: 1,
        jobId: null,
        dataTableProps: null,
        keyUploader: 0,
        dialogMessage: null,
        dialog: false,
        propsHeader: {'region': null, 'date': null, 'original_date': null, 'client': null, 'time_window': null, "service": null},
        results: null,
        manifestCheckerActive: false,

      }
    },
    methods: {
      // @vuese
      // Scrolls down to the end of the page after having stored the job_id returned by the API once the manifest
      // has been uploaded
      // @arg Takes a job_id and stores it
      manifestSubmitted(job_id) {
        this.jobId = job_id;
        this.$vuetify.goTo(9999, {duration: 1000});
        // this.el++
      },
      // @vuese
      // Gets the green light from the API saying the manifest has been checked and if so leads the user to the 2nd tab
      // of this page
      manifestChecked() {
        axios.get(process.env.API_URL + '/manifests/' + this.jobId + '/results')
          .then((response) => {
            this.dataTableProps = response.data;
            this.el = 2;
          })
          .catch((response) => {
            console.log(response.data.error);
          })
      },
      // @vuese
      // Goes back to the 1st tab of this page and resets all relevant variables to default.
      backToUpload() {
        this.jobId = null;
        this.dataTableProps = null;
        this.keyUploader++;
        this.el = 1;
      },
      // @vuese
      // Displays a message dialog.
      // @arg Takes a string message as an argument and returns it in a dialog.
      displayDialog(message) {
        this.dialogMessage = message;
        this.dialog = true;
      },
      // @vuese
      // Calls the API once the manifest has been confirmed.
      manifestConfirmed() {
        axios.post(process.env.API_URL + '/manifests/' + this.jobId + '/confirm')
          .then((response) => {
            this.jobId = response.data.job_id;
            this.manifestCheckerActive = true;
            this.$vuetify.goTo(9999, {duration: 1000});
          })
          .catch((response) => {
            this.displayDialog(response.response.data.error);
          })
      },
      // @vuese
      // Calls the API to finally check the uploaded manifest.
      manifestFinalChecked() {
        axios.get(process.env.API_URL + '/manifests/' + this.jobId + '/results')
          .then((response) => {
            this.results = response.data;
            this.el++
          })
          .catch((response) => {
            this.displayDialog('ERROR ' + response.response.data.error);
          })
      }
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/Delivery/UploadYourManifest.vue